import { createContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const FocusedThreadIdContext = /*#__PURE__*/createContext(undefined);
export const FocusedThreadIdProvider = ({
  children,
  threadId
}) => {
  return /*#__PURE__*/_jsx(FocusedThreadIdContext.Provider, {
    value: {
      focusedThreadId: threadId
    },
    children: children
  });
};
FocusedThreadIdProvider.displayName = 'FocusedThreadIdProvider';